// actions.js
import {
  FETCH_ORGANIZATION_REQUEST,
  FETCH_ORGANIZATION_SUCCESS,
  FETCH_ORGANIZATION_FAILURE,
  FETCH_LINE_MASTER_REQUEST,
  FETCH_LINE_MASTER_SUCCESS,
  FETCH_LINE_MASTER_FAILURE,
  LOGIN_REQUEST, 
  LOGIN_SUCCESS, 
  LOGIN_FAILURE,
  LOGOUT,
  SET_USER_CREDENTIALS,
  FETCH_SEASON_REQUEST,
  FETCH_SEASON_SUCCESS,
  FETCH_SEASON_FAILURE,
  FETCH_WAREHOUSE_FAILURE,
  FETCH_WAREHOUSE_REQUEST,
  FETCH_WAREHOUSE_SUCCESS,
  FETCH_DGU_REMOTE_IP_REQUEST,
  FETCH_DGU_REMOTE_IP_SUCCESS,
  FETCH_AD_USER_FAILURE,
  FETCH_AD_USER_SUCCESS,
  FETCH_AD_USER_REQUEST,
  FETCH_DGU_REMOTE_IP_FAILURE,
  FETCH_CLIENT_IP_REQUEST,
  FETCH_CLIENT_IP_SUCCESS,
  FETCH_CLIENT_IP_FAILURE,
  // FETCH_DRIER_TYPE_REQUEST,
  // FETCH_DRIER_TYPE_SUCCESS,
  // FETCH_DRIER_TYPE_FAILURE
} from "./actionTypes";

export const fetchOrganizationRequest = () => ({
  type: FETCH_ORGANIZATION_REQUEST,
});
export const fetchOrganizationSuccess = (data) => ({
  type: FETCH_ORGANIZATION_SUCCESS,
  payload: data,
});
export const fetchOrganizationFailure = (error) => ({
  type: FETCH_ORGANIZATION_FAILURE,
  payload: error,
});

export const fetchLineMasterRequest = () => ({
  type: FETCH_LINE_MASTER_REQUEST,
});
export const fetchLineMasterSuccess = (data) => ({
  type: FETCH_LINE_MASTER_SUCCESS,
  payload: data,
});
export const fetchLineMasterFailure = (error) => ({
  type: FETCH_LINE_MASTER_FAILURE,
  payload: error,
});
export const loginRequest = () => ({
  type: LOGIN_REQUEST,
});

export const loginSuccess = (user) => ({
  type: LOGIN_SUCCESS,
  payload: user,
});
export const setUserCredentials = (username, password) => ({
  type: SET_USER_CREDENTIALS,
  payload: { username, password },
});

export const loginFailure = (error) => ({
  type: LOGIN_FAILURE,
  payload: error,
});

export const logout = () => ({
  type: LOGOUT,
});
export const fetchSeasonRequest = () => ({
  type: FETCH_SEASON_REQUEST,
});

export const fetchSeasonSuccess = (data) => ({
  type: FETCH_SEASON_SUCCESS,
  payload: data,
});

export const fetchSeasonFailure = (error) => ({
  type: FETCH_SEASON_FAILURE,
  payload: error,
});

export const fetchWarehouseRequest = () => ({
  type: FETCH_WAREHOUSE_REQUEST,
});

export const fetchWarehouseSuccess = (data) => ({
  type: FETCH_WAREHOUSE_SUCCESS,
  payload: data,
});

export const fetchWarehouseFailure = (error) => ({
  type: FETCH_WAREHOUSE_FAILURE,
  payload: error,
});

// DGU Remote IP Actions
export const fetchDguRemoteIPRequest = () => ({
  type: FETCH_DGU_REMOTE_IP_REQUEST,
});

export const fetchDguRemoteIPSuccess = (ip) => ({
  type: FETCH_DGU_REMOTE_IP_SUCCESS,
  payload: ip,
});

export const fetchDguRemoteIPFailure = (error) => ({
  type: FETCH_DGU_REMOTE_IP_FAILURE,
  payload: error,
});

// AD User Actions
export const fetchADUserRequest = () => ({
  type: FETCH_AD_USER_REQUEST,
});

export const fetchADUserSuccess = (user) => ({
  type: FETCH_AD_USER_SUCCESS,
  payload: user,
});

export const fetchADUserFailure = (error) => ({
  type: FETCH_AD_USER_FAILURE,
  payload: error,
});
export const fetchClientIPRequest = () => ({
  type: FETCH_CLIENT_IP_REQUEST,
});

export const fetchClientIPSuccess = (ip) => ({
  type: FETCH_CLIENT_IP_SUCCESS,
  payload: ip,
});

export const fetchClientIPFailure = (error) => ({
  type: FETCH_CLIENT_IP_FAILURE,
  payload: error,
});